/**
 * check if an element is wholly visible in the viewport
 */
const isElementInViewport = (elementOrDomRect) => {
    if (!elementOrDomRect) {
        return false;
    }
    const elementRect = elementOrDomRect instanceof DOMRect ? elementOrDomRect : elementOrDomRect.getBoundingClientRect();
    return (elementRect.top >= 0 &&
        elementRect.left >= 0 &&
        elementRect.right <= window.innerWidth &&
        elementRect.bottom <= window.innerHeight);
};
export default isElementInViewport;
//# sourceMappingURL=isElementInViewport.js.map